import {
  CourseUnit,
  GenericReferenceId,
  ParsedTeksObjectivesItem,
  ParsedTCMPCUnit,
  TeksObjectivesItem,
  Unit,
} from "@examspark/types";

import { getTagFromResource } from "./meta/tags";

export const parseTeksObjectivesItem = (input: TeksObjectivesItem) => {
  const { data, ...rest } = input;
  const next: ParsedTeksObjectivesItem = {
    ...rest,
    data: data && typeof data === "string" ? JSON.parse(data) : data,
  };

  return next;
};

export const findUnitObjective = (
  unitObjectives: ParsedTCMPCUnit["objectives"],
  objectiveId?: string,
) => {
  if (!objectiveId) return;
  const found = unitObjectives?.find((unitObj) => unitObj.id === objectiveId);

  if (!found) return;
  return parseTeksObjectivesItem(found);
};

/** Use this method to extract the duration of a unit in a given course. */
export const getUnitDurationInCourse = (unit: Unit) => {
  const courseUnit = unit.course?.units?.find(
    (courseUnit) => unit.id === courseUnit.id,
  );

  if (courseUnit) {
    const duration = getTagFromResource(courseUnit, "duration")?.value;
    return Number(duration);
  }
};

export const getUnitDurationFromCourseUnitTag = (
  unit: CourseUnit | GenericReferenceId,
) => {
  const duration = getTagFromResource(unit, "duration")?.value;
  return Number(duration);
};
